/* eslint-disable */
export const protobufPackage = 'com.celertech.marketdata.api.enums.marketdatamidrateleveltype';

export enum MarketDataMidrateLevelType {
    NONE = 1,
    TOB = 2,
    ALL = 3,
    UNRECOGNIZED = -1
}
